import React, { useCallback } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { DeleteIcon } from "@td/ui";
import styles from "./styles.module.scss";

const NoteItem = ({ note: { id, author, note, noteCreationDt }, onDelete }) => {
  const handleDelete = useCallback(() => {
    onDelete(id);
  }, [onDelete, id]);

  return (
    <div className={styles.note}>
      <div className={styles.noteHeader}>
        <div data-testid="note-author-name" >
          {author.name}
        </div>
        <div
          className={styles.noteCreatedAt}
          data-testid="note-created-at"
        >
          {moment(noteCreationDt).format("MMM-D-YYYY hh:mm A")}
        </div>
      </div>
      <div
        className={styles.noteContent}
        data-testid="note-content"
      >
        {note}

        <button
          type="button"
          className={styles.noteDeleteButton}
          onClick={handleDelete}
        >
          <DeleteIcon
            width={12}
            height={12}
            fill="#181919"
          />
        </button>
      </div>
    </div>
  );
};

NoteItem.propTypes = {
  note: PropTypes.shape({
    id: PropTypes.string.isRequired,
    author: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    note: PropTypes.string.isRequired,
    noteCreationDt: PropTypes.string.isRequired,
  }),
  onDelete: PropTypes.func.isRequired,
};

export default NoteItem;
